import logo from './logo.svg';
import './App.css';
import Mainroutes from './Pages/Mainroutes';

function App() {
  return (
    <div className="App">
      <Mainroutes/>
    </div>
  );
}

export default App;
